import { ElementType, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { TabsProps } from '@mui/material/Tabs';
import { last, some, split } from 'lodash';

export const useNavigateToFirstTab = (tabs: TabsProps<ElementType>[]) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathValue = last(split(location.pathname, '/'));

    if (!some(tabs, tab => tab.to === pathValue)) {
      navigate(tabs[0]?.to);
    }
  }, []);
};
